export default __webpack_public_path__ + "static/media/What-we-do-Landing page-Digital Product Experience and Design.59a700cb.png";